import React from "react";
import { motion, useScroll } from "framer-motion";

// Hairline royal progress bar tracking page scroll, fixed at the viewport top.
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  return (
    <motion.div
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 h-[3px] bg-royal origin-left z-[60]"
      style={{ scaleX: scrollYProgress }}
    />
  );
}
